import $ from 'jquery';
/* global x5script */

class MortgageApplication {
  constructor() {
    this.appData = x5script.mortgageApp;

    this.selectors = {
      app: '.js-mortgage-app',
      page: '.gform_page',
      previousButton: '.gform_previous_button',
      nextButton: '.gform_next_button, .gform_button',
      fieldWrapper: '.gfield',
      fieldLabel: '.gfield_label',
      summaryContent: '.js-summary',
    };

    this.elements = {
      app: $(this.selectors.app),
    };

    this.classes = {
      active: 'is-active',
    };

    this.settings = {
      formId: 0,
      currentPage: 1,
      corner: 'bottom-right',
      buttonsDefaultLabels: {
        prev: '',
        next: '',
      },
      summaryData: [],
      summaryStepNumber: parseInt(this.appData.summaryStepNumber, 10),
    };

    this.corners = ['top-right', 'bottom-right', 'bottom-left', 'top-left'];

    if (!this.elements.app.length) {
      return;
    }

    $(document).on('gform_post_render', (event, formId, currentPage) => {
      this.removeClasses();
      this.settings.currentPage = parseInt(currentPage, 10);
      this.settings.formId = parseInt(formId, 10);

      this.elements.page = this.elements.app.find(
        `${this.selectors.page}#gform_page_${
          this.appData.formId
        }_${currentPage}`,
      );
      this.elements.previousButton = this.elements.page.find(
        this.selectors.previousButton,
      );
      this.elements.nextButton = this.elements.page.find(
        this.selectors.nextButton,
      );

      if (this.elements.previousButton.length) {
        this.settings.buttonsDefaultLabels.prev = this.elements.previousButton.text();
      }

      if (this.elements.nextButton.length) {
        this.settings.buttonsDefaultLabels.next = this.elements.nextButton.text();
      }

      this.setCorner();
      this.setClasses();
      this.setupButtons();
      this.setSummaryData();
    });
  }

  setCorner() {
    const newCorner = this.settings.currentPage % 4;
    this.settings.corner = this.corners[newCorner];
  }

  getButtonData(type) {
    const data = this.appData.buttons;

    return data[type];
  }

  getButtonText(type) {
    const buttonData = this.getButtonData(type);
    const buttonLabel = buttonData[`step-${this.settings.currentPage}`];

    if (!buttonLabel) {
      return this.settings.buttonsDefaultLabels[type];
    }

    return buttonLabel;
  }

  removeClasses() {
    this.elements.app.removeClass(`is-page-${this.settings.currentPage}`);

    $.each(this.corners, (i, corner) => {
      this.elements.app.removeClass(`has-corner-${corner}`);
    });

    const activePages = this.elements.app.find(
      `${this.selectors.page}.is-active`,
    );

    if (activePages.length) {
      activePages.removeClass(this.classes.active);
    }
  }

  setClasses() {
    this.elements.app.addClass(
      `is-page-${this.settings.currentPage} has-corner-${this.settings.corner}`,
    );

    this.elements.page.addClass(this.classes.active);
  }

  setupButtons() {
    const prevButtonText = this.getButtonText('prev');
    const nextButtonText = this.getButtonText('next');

    if (prevButtonText && this.elements.previousButton.length) {
      const buttonData = this.getButtonData('prev');
      this.elements.previousButton.html(`${buttonData.icon} ${prevButtonText}`);
    }

    if (nextButtonText && this.elements.nextButton.length) {
      const buttonData = this.getButtonData('next');

      if (this.settings.currentPage > 2) {
        this.elements.nextButton.html(`${nextButtonText} ${buttonData.icon}`);
      } else {
        this.elements.nextButton.text(nextButtonText);
      }
    }

    switch (this.settings.currentPage) {
      case 2:
        this.elements.previousButton.hide();
        break;
      default:
        break;
    }
  }

  setSummaryData() {
    if (this.settings.summaryStepNumber === this.settings.currentPage) {
      const contactDetailsStepNumber = this.settings.summaryStepNumber - 1;
      const page = $(this.elements.app).find(
        `#gform_page_${this.settings.formId}_${contactDetailsStepNumber}`,
      );

      if (page.length) {
        const fields = page.find(this.selectors.fieldWrapper);

        if (fields.length) {
          $.each(fields, (i, el) => {
            const field = $(el);

            const label = field.find(this.selectors.fieldLabel);
            const input = field.find('input, select').first();

            if (label.length && input.length) {
              this.settings.summaryData.push({
                label: label.text(),
                value: input.val(),
              });
            }
          });
        }

        this.generateSummary();
      }
    }
  }

  generateSummary() {
    const page = $(this.elements.app).find(
      `#gform_page_${this.settings.formId}_${this.settings.summaryStepNumber}`,
    );

    if (page.length) {
      const summaryContent = page.find(this.selectors.summaryContent);

      if (summaryContent.length) {
        let html = '<div class="c-mortgage-app__summary">';

        this.settings.summaryData.forEach(({ label, value }) => {
          if (value.trim() !== '') {
            html += `<div class="c-mortgage-app__summary-row">
              <div class="c-mortgage-app__summary-col c-mortgage-app__summary-col--label">${label}</div>
              <div class="c-mortgage-app__summary-col c-mortgage-app__summary-col--value has-font-headings"><strong>${value}</strong></div>
            </div>`;
          }
        });

        html += '</div>';

        summaryContent.html(html);
      }
    }
  }
}

export default new MortgageApplication();



// WEBPACK FOOTER //
// ./src/scripts/modules/mortgage-application.js